import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import api from "../../api/axios";
import { ErroContainer } from "../../styles/GlobalStyles";
import { toast } from "react-toastify";

export const EditSkillModal = ({ open, onClose, mode, skill }) => {
  const [values, setValues] = useState({
    _id: "",
    name: "",
  });

  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    const isFormValid = Object.values(values).every((v) => v !== "");

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    if (mode === "create") {
      try {
        await api.post(`/skill/create`, values);
        resetValues();
        onClose();
      } catch (error) {
        toast.error(error);
      }
    } else {
      try {
        await api.put(`/skill/update/${values._id}`, values);
        resetValues();
        onClose();
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/skill/delete/${values._id}`);
      resetValues();
      onClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleClose = () => {
    resetValues();
    setError("");
    onClose();
  };

  const resetValues = () => {
    setValues({
      _id: "",
      name: "",
    });
  };

  useEffect(() => {
    if (skill) {
      setValues(skill);
    }
  }, [skill]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">{`${
        mode === "edit"
          ? "Editar"
          : mode === "create"
            ? "Criar Nova"
            : "Deseja remover esta"
      } Habilidade${
        mode === "delete" ? "? (Essa ação é irreversível)" : ""
      }`}</DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            width: "100%",
            minWidth: "300px",
            gap: "1.5rem",
          }}
        >
          <TextField
            label="Nome"
            id="name"
            name="name"
            type="text"
            value={values.name}
            disabled={mode === "delete"}
            onChange={(e) => {
              setValues({ ...values, name: e.target.value });
              setError("");
            }}
          />
        </Stack>
        <ErroContainer>{error ? error : ""}</ErroContainer>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          sx={{ backgroundColor: "#104467", color: "white" }}
          onClick={mode === "delete" ? handleDelete : handleSubmit}
          variant="contained"
        >
          {mode === "delete" ? "Confirmar" : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
